var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginbox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "loginbox-container" }, [
      _c("header", [_vm._v("\n\t\t\tSign In\n\t\t")]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form-container",
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.login({ email: _vm.email, password: _vm.password })
            }
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            attrs: {
              type: "email",
              name: "email",
              placeholder: "Email address",
              required: "",
              disabled: _vm.loading === true,
              autocomplete: "new-password"
            },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: {
              type: "password",
              name: "password",
              placeholder: "Password",
              required: "",
              disabled: _vm.loading === true,
              autocomplete: "new-password"
            },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              class: { submit: true, loading: _vm.loading, login: _vm.login },
              attrs: { disabled: _vm.loading === true, type: "submit" }
            },
            [
              _vm.loading === false
                ? _c("span", [_vm._v("\n\t\t\t\t\tLogin   ⟶\n\t\t\t\t")])
                : _vm._e(),
              _vm._v(" "),
              _vm.loading === true
                ? _c("span", [_vm._v("\n\t\t\t\t\tSigning In...   \n\t\t\t\t")])
                : _vm._e()
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "account-tos" }, [
      _vm._v("\n\t\tDon't have an account?\n\t\t"),
      _c("a", { attrs: { href: _vm.URL_PREFIX + "/register" } }, [
        _vm._v("Sign Up")
      ]),
      _vm._v(".\n\t")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "/" } }, [
      _c("img", {
        staticClass: "mobile",
        attrs: { src: "/static/logo-head-white.svg" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01982c0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01982c0f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginBox/LoginBox.vue
// module id = null
// module chunks = 